import React from 'react'
import { useTranslation } from 'react-i18next'

import Box from '@/modules/components/Box'
import Flex from '@/modules/components/Flex'
import Typography from '@/modules/components/Typography'

import type { Section } from '../../data/types'
import { ProductCategory } from './ProductCategory'

export const ProductMenu = ({
  products,
  onClickMenuLink,
}: {
  products: Section[]
  onClickMenuLink: () => void
}) => {
  const { t } = useTranslation('navigation')
  return (
    <Box px={8}>
      {products.map(({ tTitle, items }, i) => (
        <Box key={tTitle}>
          <Flex py={4}>
            {tTitle && (
              <Typography
                variant="h5"
                color="secondaryDarkGrey"
                flex={[1 / items.length + 1]}
                pr={7}
                maxWidth={['338px']}
              >
                {t(tTitle)}
              </Typography>
            )}
            {items.map((category) => (
              <Box
                key={category.tTitle}
                flex={[1 / items.length + 1]}
                paddingRight={i !== items.length - 1 ? 6 : 0}
                order={1}
              >
                <ProductCategory
                  category={category}
                  translateFn={t}
                  onClick={onClickMenuLink}
                />
              </Box>
            ))}
          </Flex>
          {i !== products.length - 1 && (
            <Box height={0.5} bg="secondaryDarkGrey" />
          )}
        </Box>
      ))}
    </Box>
  )
}
